import APIService from './APIService';

export default {
  getScriptsAtivos() {
    return APIService.apiCall().get('scripts-modelos/get-ativos');
  }
};
